import React from 'react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

const Anchor = (props) => {
  const {
    setShowPopUp,
    fieldValue,
    fieldId,
    triggerPopUpId,
    cssProperties,
  } = props;
  const handleOpen = () => setShowPopUp(triggerPopUpId);
  return (
    <div>
      {
/* eslint-disable jsx-a11y/anchor-is-valid -- desc */
      }
      <a href="#" onClick={handleOpen} className={cssProperties.style} id={fieldId}>
        {parseHtml(fieldValue)}
      </a>
      {
/* eslint-enable jsx-a11y/anchor-is-valid -- desc */
      }
    </div>

  );
};

Anchor.propTypes = {
  setShowPopUp: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldId: PropTypes.string,
  triggerPopUpId: PropTypes.string,
  cssProperties: PropTypes.objectOf(PropTypes.shape),
};

export default Anchor;
